import React, { useContext } from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { ThemeContext } from "../../context/ThemeContext";

const PieChartComponent = ({ data }) => {
    const { isDarkMode } = useContext(ThemeContext);

    // Convert object to array for Recharts
    const formattedData = Object.entries(data).map(([key, value]) => ({
        name: key,
        value: value,
    }));

    const colors = !isDarkMode ? ["#C2000F", "#5D8F15"] : ["#F95E64", "#62A575"];

    return (
        <ResponsiveContainer width="100%" height={200}>
            <PieChart>
                <Pie
                    data={formattedData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={80} // Ensures proper sizing
                >
                    {formattedData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                    ))}
                </Pie>
                <Tooltip />
                <Legend />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default PieChartComponent;
